// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll_b4c50a27 {
  position: relative;
  top: 0.667rem;
  height: calc(100% - 1.334rem);
  width: 0.667rem;
  border-radius: 0.667rem;
  margin: 0 0.334rem;
  overflow: hidden;
  z-index: 11;
}
.scroll_horizontal_b4c50a27 {
  top: auto;
  left: 0.667rem;
  width: calc(100% - 1.334rem);
  height: 0.667rem;
  margin: 0.334rem 0;
}
.scroll_horizontal_b4c50a27 .scroll__handle_b4c50a27 {
  min-width: 2.667rem;
  right: auto;
  bottom: 0;
  min-height: 0;
  cursor: pointer;
}
.scroll_light_b4c50a27 {
  background-color: #eaedef;
}
.scroll_light_b4c50a27 .scroll__handle_b4c50a27 {
  background-color: #84919b;
}
.scroll_light_b4c50a27 .scroll__handle_b4c50a27:active,
.scroll_light_b4c50a27 .scroll__handle_b4c50a27:hover {
  background-color: #657682;
}
.scroll_dark_b4c50a27 {
  background-color: #84919b;
}
.scroll_dark_b4c50a27 .scroll__handle_b4c50a27 {
  background-color: #eaedef;
}
.scroll_dark_b4c50a27 .scroll__handle_b4c50a27:active,
.scroll_dark_b4c50a27 .scroll__handle_b4c50a27:hover {
  background-color: #eaedef;
}
.scroll__handle_b4c50a27 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: 2.667rem;
  border-radius: 0.667rem;
}
.scrollable_b4c50a27 {
  position: relative;
  max-width: 100%;
  height: 100%;
  touch-action: none;
}
.scrollable_enabled_b4c50a27 {
  overflow: hidden;
}
.scrollable_with-arrows_b4c50a27:hover.scrollable_start_b4c50a27::before {
  opacity: 0;
}
.scrollable_with-arrows_b4c50a27:hover.scrollable_end_b4c50a27::after {
  opacity: 0;
}
.scrollable_with-arrows_b4c50a27:hover .scrollable__arrow_b4c50a27 {
  opacity: 1;
}
.scrollable__container_b4c50a27 {
  position: relative;
}
.scrollable__container_moving_b4c50a27 {
  transition: margin 0.3s ease-out;
}
.scrollable_overlay_b4c50a27 {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  display: none;
  user-select: none;
}
.scrollable_horizontal_b4c50a27::before,
.scrollable_horizontal_b4c50a27::after {
  content: '';
  position: absolute;
  opacity: 0;
  transition: opacity 0.3s linear;
  pointer-events: none;
  z-index: 1;
}
.scrollable_horizontal_b4c50a27.scrollable_start_b4c50a27::before {
  opacity: 1;
}
.scrollable_horizontal_b4c50a27.scrollable_end_b4c50a27::after {
  opacity: 1;
}
.scrollable_vertical_b4c50a27::before,
.scrollable_vertical_b4c50a27::after {
  content: '';
  position: absolute;
  opacity: 0;
  transition: opacity 0.3s linear;
  pointer-events: none;
  z-index: 1;
}
.scrollable_vertical_b4c50a27.scrollable_start_b4c50a27::before {
  opacity: 1;
}
.scrollable_vertical_b4c50a27.scrollable_end_b4c50a27::after {
  opacity: 1;
}
.scrollable_horizontal_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27) {
  padding-bottom: 1.334rem;
}
.scrollable_horizontal_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27)::before,
.scrollable_horizontal_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27)::after {
  bottom: 1.334rem;
}
.scrollable_horizontal_b4c50a27 > .scrollable__container_b4c50a27 {
  float: left;
  min-width: 100%;
}
body:not(.with-outline) .scrollable_horizontal_b4c50a27 > .scrollable__container_b4c50a27:focus {
  outline: none;
}
.scrollable_horizontal_b4c50a27::before,
.scrollable_horizontal_b4c50a27::after {
  top: 0;
  bottom: 0;
  width: 4.000999999999999rem;
}
.scrollable_horizontal_b4c50a27::before {
  left: 0;
}
.scrollable_horizontal_b4c50a27::after {
  right: 0;
}
.scrollable_horizontal_b4c50a27.scrollable_shadow-light_b4c50a27::before {
  background-image: linear-gradient(to left, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b4c50a27.scrollable_shadow-light_b4c50a27::after {
  background-image: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b4c50a27.scrollable_shadow-dark_b4c50a27::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b4c50a27.scrollable_shadow-dark_b4c50a27::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27) {
  padding-right: 1.334rem;
}
.scrollable_vertical_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27)::before,
.scrollable_vertical_b4c50a27.scrollable_with-scroll-line_b4c50a27:not(.scrollable_absolute_b4c50a27)::after {
  right: 1.334rem;
}
body:not(.with-outline) .scrollable_vertical_b4c50a27 .scrollable__container_b4c50a27:focus {
  outline: none;
}
.scrollable_vertical_b4c50a27::before,
.scrollable_vertical_b4c50a27::after {
  height: 3.001rem;
  left: 0;
  right: 0;
}
.scrollable_vertical_b4c50a27::before {
  top: 0;
}
.scrollable_vertical_b4c50a27::after {
  bottom: 0;
}
.scrollable_vertical_b4c50a27.scrollable_shadow-light_b4c50a27::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b4c50a27.scrollable_shadow-light_b4c50a27::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b4c50a27.scrollable_shadow-dark_b4c50a27::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.4));
}
.scrollable_vertical_b4c50a27.scrollable_shadow-dark_b4c50a27::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.4));
}
.scrollable_absolute_b4c50a27 > .scroll_b4c50a27 {
  opacity: 0;
  transition: opacity 0.3s linear;
}
.scrollable_absolute_b4c50a27 > .scroll_dragging_b4c50a27 {
  opacity: 1;
}
.scrollable_absolute_b4c50a27:hover > .scroll_b4c50a27 {
  opacity: 1;
}
.scrollable_b4c50a27 > .scroll_b4c50a27 {
  position: absolute;
  right: 0;
  left: auto;
  top: 0.667rem;
  bottom: 0.667rem;
  height: auto;
}
.scrollable_b4c50a27 > .scroll_horizontal_b4c50a27 {
  top: auto;
  bottom: 0;
  left: 0.667rem;
  right: 0.667rem;
  height: 0.667rem;
  width: auto;
}
.scrollable__arrow_b4c50a27 {
  position: absolute;
  z-index: 10;
  font-size: 2.167rem;
  width: 4rem;
  height: 100%;
  background-color: rgba(132,145,155,0.4);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease-in;
}
.scrollable__arrow_b4c50a27:hover,
.scrollable__arrow_active_b4c50a27 {
  background-color: rgba(132,145,155,0.4);
}
.scrollable__arrow_b4c50a27:hover ~ .scrollable__container_b4c50a27,
.scrollable__arrow_active_b4c50a27 ~ .scrollable__container_b4c50a27 {
  will-change: margin;
}
.scrollable__arrow_left_b4c50a27 {
  left: 0;
}
.scrollable__arrow_right_b4c50a27 {
  right: 0;
}
.scrollable__arrow_right_b4c50a27 .scrollable__arrow-icon_b4c50a27 {
  transform: translate(100%, -50%);
}
.scrollable__arrow-icon_b4c50a27 {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `scroll_b4c50a27`,
	"scroll_horizontal": `scroll_horizontal_b4c50a27`,
	"scroll__handle": `scroll__handle_b4c50a27`,
	"scroll_light": `scroll_light_b4c50a27`,
	"scroll_dark": `scroll_dark_b4c50a27`,
	"scrollable": `scrollable_b4c50a27`,
	"scrollable_enabled": `scrollable_enabled_b4c50a27`,
	"scrollable_with-arrows": `scrollable_with-arrows_b4c50a27`,
	"scrollable_start": `scrollable_start_b4c50a27`,
	"scrollable_end": `scrollable_end_b4c50a27`,
	"scrollable__arrow": `scrollable__arrow_b4c50a27`,
	"scrollable__container": `scrollable__container_b4c50a27`,
	"scrollable__container_moving": `scrollable__container_moving_b4c50a27`,
	"scrollable_overlay": `scrollable_overlay_b4c50a27`,
	"scrollable_horizontal": `scrollable_horizontal_b4c50a27`,
	"scrollable_vertical": `scrollable_vertical_b4c50a27`,
	"scrollable_with-scroll-line": `scrollable_with-scroll-line_b4c50a27`,
	"scrollable_absolute": `scrollable_absolute_b4c50a27`,
	"scrollable_shadow-light": `scrollable_shadow-light_b4c50a27`,
	"scrollable_shadow-dark": `scrollable_shadow-dark_b4c50a27`,
	"scroll_dragging": `scroll_dragging_b4c50a27`,
	"scrollable__arrow_active": `scrollable__arrow_active_b4c50a27`,
	"scrollable__arrow_left": `scrollable__arrow_left_b4c50a27`,
	"scrollable__arrow_right": `scrollable__arrow_right_b4c50a27`,
	"scrollable__arrow-icon": `scrollable__arrow-icon_b4c50a27`
};
export default ___CSS_LOADER_EXPORT___;
